module.exports = __webpack_public_path__ + "static/img/onelocker_4.cc58f68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onelocker_4.jpg
// module id = q+Ce
// module chunks = 0